import { render, staticRenderFns } from "./Assets-move-dialog.vue?vue&type=template&id=081a8ed7&scoped=true&"
import script from "./Assets-move-dialog.vue?vue&type=script&lang=js&"
export * from "./Assets-move-dialog.vue?vue&type=script&lang=js&"
import style0 from "./Assets-move-dialog.vue?vue&type=style&index=0&id=081a8ed7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a8ed7",
  null
  
)

export default component.exports